import { Staff, Customer } from './types.tsx';
import { Role } from './enums.tsx';

export function isStaff(user: Staff | Customer | null): user is Staff {
  return (
    !!user &&
    'roleName' in user &&
    (user.roleName === Role.Admin || user.roleName === Role.General || user.roleName === Role.SiteAdmin)
  );
}


export function isAdmin(user: Staff): boolean {
  return user.roleName === Role.Admin || user.roleName === Role.SiteAdmin;
}

export function isGlobalAdmin(user: Staff | Customer | null): user is Staff {
  return isStaff(user) && user.roleName === Role.Admin;
}

export function isSiteAdmin(user: Staff | Customer | null): user is Staff {
  return isStaff(user) && user.roleName === Role.SiteAdmin;
}